import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { pickmeup } from 'pickmeup';

@Injectable()
export class PickmeupService {

	constructor(
		private translate: TranslateService
	) {}

	get translates() {
		return {
			days: [
				this.translate.instant('Воскресенье'),
				this.translate.instant('Понедельник'),
				this.translate.instant('Вторник'),
				this.translate.instant('Среда'),
				this.translate.instant('Четверг'),
				this.translate.instant('Пятница'),
				this.translate.instant('Суббота')
			],
			daysShort: [
				this.translate.instant('Вс'),
				this.translate.instant('Пн'),
				this.translate.instant('Вт'),
				this.translate.instant('Ср'),
				this.translate.instant('Чт'),
				this.translate.instant('Пт'),
				this.translate.instant('Сб')
			],
			daysMin: [
				this.translate.instant('Вс'),
				this.translate.instant('Пн'),
				this.translate.instant('Вт'),
				this.translate.instant('Ср'),
				this.translate.instant('Чт'),
				this.translate.instant('Пт'),
				this.translate.instant('Сб')
			],
			months: [
				this.translate.instant('Январь'),
				this.translate.instant('Февраль'),
				this.translate.instant('Март'),
				this.translate.instant('Апрель'),
				this.translate.instant('Май'),
				this.translate.instant('Июнь'),
				this.translate.instant('Июль'),
				this.translate.instant('Август'),
				this.translate.instant('Сентябрь'),
				this.translate.instant('Октябрь'),
				this.translate.instant('Ноябрь'),
				this.translate.instant('Декабрь')
			],
			monthsShort: [
				this.translate.instant('Янв'),
				this.translate.instant('Фев'),
				this.translate.instant('Мар'),
				this.translate.instant('Апр'),
				this.translate.instant('Май'),
				this.translate.instant('Июн'),
				this.translate.instant('Июл'),
				this.translate.instant('Авг'),
				this.translate.instant('Сен'),
				this.translate.instant('Окт'),
				this.translate.instant('Ноя'),
				this.translate.instant('Дек')
			]
		};
	}

	public setDefaultOptions() {
		if ( typeof pickmeup === 'undefined' ) {
			setTimeout( function () {
				this.setDefaultOptions();
			}.bind( this ), 100 );
			return;
		}
		pickmeup.defaults.format = 'd.m.Y';
		pickmeup.defaults.locales['en'] = this.translates;
	}

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/pickmeup.service.ts